var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.75 15.7502L12.4927 12.4929M12.4927 12.4929C13.0499 11.9357 13.4919 11.2743 13.7934 10.5463C14.0949 9.81834 14.2501 9.03811 14.2501 8.25015C14.2501 7.4622 14.0949 6.68197 13.7934 5.95399C13.4919 5.22602 13.0499 4.56457 12.4927 4.0074C11.9356 3.45024 11.2741 3.00827 10.5461 2.70673C9.81816 2.4052 9.03792 2.25 8.24997 2.25C7.46202 2.25 6.68178 2.4052 5.95381 2.70673C5.22584 3.00827 4.56439 3.45024 4.00722 4.0074C2.88197 5.13265 2.24982 6.65881 2.24982 8.25015C2.24982 9.84149 2.88197 11.3677 4.00722 12.4929C5.13247 13.6182 6.65863 14.2503 8.24997 14.2503C9.84131 14.2503 11.3675 13.6182 12.4927 12.4929Z",
    stroke: "#B1B1B1",
    strokeWidth: 2.08333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.ad587931caacdd54e71c8b09702f4910.svg";
export { ForwardRef as ReactComponent };